export default __webpack_public_path__ + "static/media/JobFour2.4e31e969.jpg";